export function api() {
	if (import.meta.env.VITE_API_ENDPOINT) {
		return import.meta.env.VITE_API_ENDPOINT;
	}
	return `${window.location.origin}/api/v1/`;
}
